<template>
  <div>
    <h3 v-if="create_with_user_ids_array">
      You can create more student groups in Course Properties
    </h3>
    <h3 style="text-align:center;">
      Student grouping will help when marking attendance. You can mark the attendance of a group of students (for
      example, in a lab) at once
    </h3>
    <global-group-dash :model_id="courseId" :model_type="'Course'"
      :create_with_user_ids_array="create_with_user_ids_array" :create_with_summary="create_with_summary"
      :create_with_name="create_with_name"></global-group-dash>
  </div>
</template>

<script>
import GlobalGroupDash from "../../../../globalgroup/dashboard.vue";
export default {
  props: [
    "courseId",
    "create_with_user_ids_array",
    "create_with_summary",
    "create_with_name",
  ],
  created() { },
  components: {
    GlobalGroupDash: GlobalGroupDash,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
